import { c as _c } from "react/compiler-runtime";
import { CircleSpinnerInline } from '@newfront-insurance/core-ui';
import { cn } from '@newfront-insurance/core-ui/v2';
interface ProgressMessageProps {
  message: string;
}
export function ProgressMessage(t0) {
  const $ = _c(5);
  const {
    message
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("relative inline-flex w-auto items-center gap-3 rounded-lg", "overflow-hidden");
    t2 = <div className="animate-shimmer pointer-events-none absolute inset-0 z-10 bg-gradient-to-r from-transparent via-white to-transparent opacity-30" />;
    t3 = <CircleSpinnerInline size={16} />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== message) {
    t4 = <div className="group/message mx-auto w-full max-w-[800px] px-8"><div className={t1}>{t2}{t3}<span className="text-steel-400 relative z-0 text-sm font-semibold">{message}</span></div></div>;
    $[3] = message;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}